import React from "react";
import PropTypes from "prop-types";
import Asset from "rialto-icons/Asset";

import BackgroundImage from "components/BackgroundImage";
import Translate from "utils/translate";

import styles from "./CompanyTooltip.css";

const { t } = new Translate("CompanyTooltip");

const CompanyTooltipBody = ({ assets, company, countryOfCurrentUser }) => {
  const assetsInCountry = assets.filter(
    (a) => a.country && a.country.id === countryOfCurrentUser.id
  );
  const noOfAssetsInCountry = assets && assetsInCountry.length;

  return (
    <div className={styles.body}>
      <div className={styles.header}>
        <div className={styles.logo}>
          {company.logoUrl && (
            <BackgroundImage src={company.logoUrl} style={{ backgroundSize: "contain" }} />
          )}
        </div>
        <div className={styles.details}>
          <div className={styles.name}>{company.name}</div>
          <div className={styles.tagline}>{company.tagline}</div>
          {noOfAssetsInCountry !== 0 && (
            <div className={styles.assetsInfo}>
              <Asset />
              <span>
                <strong>{t("numberOfAssets", { smart_count: noOfAssetsInCountry })}</strong>
                &nbsp;
                {t("inCountry", { value: countryOfCurrentUser.name })}
              </span>
            </div>
          )}
        </div>
      </div>
      {(company.email || company.phone) && (
        <div className={styles.contact}>
          <span>
            <a href={`mailto:${company.email}`}>{company.email}</a>
          </span>
          <span>
            <a href={"tel:".concat(company.phone).replace(/\s/g, "")}>{company.phone}</a>
          </span>
        </div>
      )}
      {assets.length > 0 && (
        <div className={styles.assets}>
          {assetsInCountry.slice(0, 5).map((a, index) => (
            <BackgroundImage key={index} src={a.avatar}>
              {assetsInCountry.length > 5 && index === 4 && (
                <div className={styles.overlay}>+{assetsInCountry.length - 5}</div>
              )}
            </BackgroundImage>
          ))}
        </div>
      )}
      <div className={styles.viewProfile}>
        <a className={styles.button} href={`/companies/${company.slug}`}>
          {t("viewCompanyProfile")}
        </a>
      </div>
    </div>
  );
};

CompanyTooltipBody.propTypes = {
  countryOfCurrentUser: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      avatar: PropTypes.string,
    })
  ),
  company: PropTypes.shape({
    logoUrl: PropTypes.string,
  }),
};

export default CompanyTooltipBody;
